/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const Loaders = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$body: $('body'),
	$bodySingleProduct: $('body.single-product'),
	$bodyProductListing: $('body.woocommerce-shop'),
	classLoader: 'loader-visible',

	/** @description Initialize */
	init: function() {
		this.loaderVisibleOnClick($('.menu-item:not(.menu-item--spec) a:not([href="#"])'));
		$('.products-compare__bar-btn').on('click', function() {
			$('body').addClass('loader-visible');
		});
		$('.compare-block__no-products-btn').on('click', function() {
			$('body').addClass('loader-visible');
		});
		$(document.body).on('added_to_cart', function() {
			$('body').removeClass('loader-visible');
		});
		window.onpageshow = event => {
			if (event.persisted) {
				$('body').removeClass('loader-visible');
			} else {
				console.log("Page loaded normally");
			}
		}
		$(document).ready(function() {
			setTimeout(() => {
				if ($('.product-box__image') || $('.product-box__info-text')) {
					$('.product-box__image').on('click', function() {
						$('body').addClass('loader-visible');
					});
					$('.product-box__info-text').on('click', function() {
						$('body').addClass('loader-visible');
					});
				}
			}, 1000);
			$('a, button').on('click', function(event) {
				const href = $(this).attr('href');
				const target = $(this).attr('target');
				const isAllowClick = $(this).hasClass('js-allow-click');
				const isUsloviPage = window.location.href.includes('uslovi-koriscenja-i-prodaje');
				if (isAllowClick) {
					return;
				}
				if (isUsloviPage && isAllowClick) {
					return;
				}

				if (
					href &&
					href !== '#' &&
					href !== 'javascript:;' &&
					href !== 'javascript:' &&
					!href.includes('tel:') &&
					!href.includes('mailto:') &&
					target !== '_blank' &&
					!$(this).hasClass('single-product__upper-right-tabs-btn') ||
					$(this).data('redirect')
				) {
					// if ($('body').hasClass('loader-hide')) {
					// 	$('body').removeClass('loader-hide');
					// }
					$('body').addClass('loader-visible');
				}
			});
			$(window).on('load', function() {
				$('body').removeClass('loader-visible');
			});
		});
	},

	loaderVisibleOnClick: function(element) {
		element.on('click', function() {
			Loaders.$body.addClass(Loaders.classLoader);
			$('body').addClass('before-visible');
		});
	},
};

export default Loaders;
